// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"35cca6cf","864":"fd9ab6ca"}[chunkId] + ".chunk.css";
};